import React, { useEffect, useRef, useContext, useState } from 'react';
import { MyCoursesHero, ProgressSection, ModulesSection, FAQSection } from "../components/MyCoursesElements"
import { PricingSection } from "../components/HomeElements"
import Purchase from '../components/Stripe/Purchase';

import "./my-courses.css"

// Main My Courses Page Component
const MyCoursesPage = () => {
  const [bloggingCourse, setBloggingCourse] = useState();
  const [loading, setLoading] = useState(true);
  const [courseService, setCourseService] = useState();
  const [checkoutData, setCheckoutData] = useState(null);
  const [customerCards, setCustomerCards] = useState([]);
  const rand = useRef();
  const purchaseRef = useRef();

  // Module data with progress
  useEffect(() => {
    (async function () {
      const mongoUrl = new URL(`https://bridge.hackernoon.com/p/courses`);
      // const mongoUrl = new URL(`http://localhost:8087`);
      // mongoUrl.searchParams.append("id", "68b959f9eeb27a895ba20f48");
      const firebase = (await import("firebase/app")).default;

      if (!firebase.auth().currentUser) return;

      const token = await firebase.auth().currentUser.getIdToken();

      try {
        const req = await fetch(mongoUrl?.toString(), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const response = await req.json();

        // console.log("Service Response", response);
        if (response?.ok === true) {
          // console.log("heree", response)
          setBloggingCourse(response?.course);
        }else {
          // console.log("im heree", response);
          await getCourseService();
        }
      } catch (e) {
        console.log("something went wrong!", e);
      }
      setLoading(false);
    })()
  }, []);

  const handleClickOutside = e => {
    const elmId = e?.target?.id;
    if (!purchaseRef?.current?.contains(e.target) && elmId !== "buy-btn") {
      if (checkoutData) {
        setCheckoutData(null);
      }
    }
  };


  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  const getCourseService = async () => {
    if(courseService) return;
    // const firebase = (await import("@/firebase")).default;

    // if (!firebase.auth().currentUser) return;

    // const token = await firebase.auth().currentUser.getIdToken();
    const mongoUrl = new URL(`https://bridge.hackernoon.com/p/hackernoonMongo2/services`);
    // const mongoUrl = new URL(`http://localhost:8086/services`);
    mongoUrl.searchParams.append("id", "68b959f9eeb27a895ba20f48");

    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
      });
      const response = await req.json();

      // console.log("Service Response", response);
      if (response.ok === true) {
        const s = response?.serviceData;
        const options = s?.priceOptions.map(p => {
          return { ...p, price: parseFloat(p.price["$numberDecimal"]) };
        });
        // console.log("heree", s)
        setCourseService({ ...s, priceOptions: options });
        rand.current = Math.floor(Math.random() * 100) + 1;
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  }

  const handleSetCheckoutData = async () => {
    if (checkoutData) {
      return setCheckoutData(null);
    }

    if (!courseService) return;

    const  headers = {
      "Content-Type": "application/json"
    }

    const firebase = (await import("firebase/app")).default;

    if (firebase.auth().currentUser) {
      const token = await firebase.auth().currentUser.getIdToken();
      const bearer = `Bearer ${token}`;
      headers["Authorization"] = bearer;
    }

    const url = new URL("https://bridge.hackernoon.com/p/hackernoonMongo2/services/single-checkout")
    // const url = new URL("http://localhost:8087/services/single-checkout");
    url.searchParams.append("optionId", courseService?.priceOptions[0]?._id);
    url.searchParams.append("serviceId", courseService?._id);
    url.searchParams.append("recurrence", "none");
    
    const params = {};

    try {
      const req = await fetch(url?.toString(), {
        method: "GET",
        headers,
        // credentials: "include",
      });
      const response = await req.json();
      // console.log("yoo heree", response)
      if (response.ok === true) {
        const data = {
          ...response?.checkoutData,
          params: { ...response?.checkoutData?.params, ...params },
        };

        setCheckoutData(data);
        if (response?.customerCards && response?.customerCards?.length > 0) {
          setCustomerCards(response?.customerCards);
        }
        // close();
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  };

  const applyCoupon = async (discount_code, params, paymentIntentId) => {
    const mongoUrl = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/validate-single-service-coupon",
    );
    // const mongoUrl = new URL("http://localhost:8087/services/validate-single-service-coupon");
    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: bearer,
        },
        body: JSON.stringify({discountCode: discount_code, ...params, paymentIntentId}),
        // mode: "cors",
        // credentials: "include",
      });
      const response = await req.json();
      // console.log("response", response);
      if (response.ok) {
        setCheckoutData(prev => ({ ...prev, ...response?.checkoutData}));
        return true;
      }else {
        return false;
      }
    } catch (e) {
      console.log("something went wrong!", e);
      return false;
    }
  }



  const faqs = [
    {
      question: "Do I need to be an experienced writer to join?",
      answer: `Not at all. This course is built for people in tech who want to start writing, even if they've never published before. Many fellows have gone from zero to published authors in just weeks using the same exercises that grew HackerNoon's 4M+ reader base.
      <br><br>
      At the same time, it's also valuable for seasoned professionals - like cybersecurity experts, software engineers, and even PhDs - who already write but want to boost their blog quality, consistency, and impact.`
    },
    {
      question: "How long does it take to complete the course?",
      answer: "Most students complete the 8 modules in 6-8 weeks, but since it's self-paced, you can go faster or slower. You have lifetime access, so there's no rush. Many students start seeing career benefits after publishing just their first few articles."
    },
    {
      question: "What if I don't have time to blog regularly?",
      answer: "The course teaches you how to blog efficiently. Many successful students publish just once or twice a month. It's about consistency and quality, not quantity. Even publishing quarterly can significantly impact your career trajectory."
    },
    {
      question: "Will I really get published on HackerNoon?",
      answer: "Yes! Course graduates have published over 850 articles on HackerNoon. Our editorial team helps ensure your work meets publication standards. Plus, you'll learn the insider secrets that get articles featured and promoted to our 4M+ monthly readers."
    },
    {
      question: "How is this different from other writing courses?",
      answer: "Most writing courses are generic. This is specifically for people in tech, taught by the team that built one of the world's largest tech publications. You're not just learning to write - you're learning to build your career through strategic content creation."
    },
    {
      question: "What if I'm not technical enough?",
      answer: "If you work in tech - whether you're a developer, designer, product manager, or in sales/marketing at a tech company - you have valuable insights to share. The course shows you how to identify and communicate your unique perspective, regardless of your technical depth."
    },
    {
      question: "I cannot afford the course. Do you offer financial aid?",
      answer: `Yes! Students with verified status qualify for our discounted rate. The easiest proofs are a school-issued email address or a valid student ID card, but we'll also accept an enrollment/acceptance letter, transcript, tuition receipt, or an ISIC (International Student Identity Card).
      <br><br>
      You'll go through a separate flow, pay $149 upfront (50% off), and once we confirm your status, you'll receive an access code to unlock the course.
      <br><br>
      Not a student? You can still apply for financial aid. You'll go through this form to submit as a non-student, and you'll need to be more thorough in your responses — explain why you deserve support, how the course will help your career or personal growth, and why the discounted rate is necessary for you to participate.`
    },
    {
      question: "What's the refund policy?",
      answer: `You can request a full refund within 7 days of purchase if you decide the program isn't for you. To be eligible, please submit your refund request within this period via this form.
      <br><br>
      Please note that participants who receive a refund will not be eligible for a course certificate and will lose access to the private community. Refunds are not available after the 7-day period has passed.`
    },
    {
      question: "Can this really help my career?",
      answer: "Our students regularly report promotions, job offers, speaking opportunities, and consulting contracts that came directly from their published articles. In tech, demonstrating your thinking through writing is one of the fastest ways to stand out and advance your career."
    },
    {
      question: "How much better off am I if I blog every week?",
      answer: "Weekly bloggers in our community often see more career opportunities, faster promotions, and greater recognition in their field. You become the person others think of first for partnerships, speaking engagements, and leadership roles. It's compound growth - each post builds on the last."
    },
    {
      question: "What if I become known as the expert in my field?",
      answer: "That's exactly what happens! Our most successful students become the go-to voices in their niches. They get invited to conferences, consulted on major decisions, and often become the face of their companies' thought leadership. Your expertise stops being a secret and starts being your career advantage."
    }
  ];

  if(loading) { 
    return (
      <div className="loading-component">
        <lottie-player 
          src="/loader_lottie.json" 
          background="transparent" 
          speed="1" 
          style={{width: '300px', height: '300px'}}
          loop 
          autoplay>
        </lottie-player>
      </div>
    )
  }


  return (
    <>
      {bloggingCourse ? (
        <>
          <MyCoursesHero 
            completedModules={(bloggingCourse?.modules || [])?.filter(item => item?.completed === true)?.length} 
            totalModules={bloggingCourse?.modules?.length} 
            courseCompleted={bloggingCourse?.completed}
          />
          <ProgressSection modules={bloggingCourse?.modules || []} />
          <ModulesSection modules={bloggingCourse?.modules || []} />
        </>
        ) : (
          <div>
            {courseService && (
              <>
                <PricingSection
                  title="No Courses Yet, But You Can Change That!"
                  courseService={courseService}
                  handleSetCheckoutData={handleSetCheckoutData}
                  rand={rand.current}
                />
                <div ref={purchaseRef}>
                  <Purchase 
                    showPurchase={checkoutData !== null} 
                    checkoutData={checkoutData} 
                    customerCards={customerCards} 
                    applyCoupon={applyCoupon}
                  />
                </div>
              </>
            )}
          </div>
        )}
      <FAQSection faqs={faqs} />
    </>
  );
};

export default MyCoursesPage;
